import type { DrizzleDB } from '../database/types';

export const setDebugDb = (database: DrizzleDB | null) => {
  if (typeof window !== 'undefined') {
    (window as Window & { __DRIZZLE_DB__?: DrizzleDB | null }).__DRIZZLE_DB__ =
      database;
  }
};

// The web client is loaded inside the mobile app's WebView solely to render the
// Cesium map (there is no React Native Cesium). The local OPFS database is never
// used in that context and OPFS init fails inside WKWebView, so we detect the RN
// WebView host and skip the local DB entirely. react-native-webview injects this
// global before content loads.
export const isReactNativeWebView = (): boolean =>
  typeof window !== 'undefined' && 'ReactNativeWebView' in window;

export const checkDatabaseSupport = async (): Promise<{
  supported: boolean;
  reason?: string;
}> => {
  if (typeof window === 'undefined') {
    return { supported: true };
  }

  // No OPFS = no local DB; surface a clean "unavailable" instead of a worker crash.
  if (!navigator.storage?.getDirectory) {
    return {
      supported: false,
      reason:
        'Origin Private File System (OPFS) is not available in this browser. The local database is disabled.'
    };
  }

  try {
    await navigator.storage.getDirectory();
    return { supported: true };
  } catch {
    return {
      supported: false,
      reason:
        'Origin Private File System (OPFS) is not available. This may happen in private/incognito mode.'
    };
  }
};
